import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Message, OverlayPanel, SelectItem } from 'primeng/primeng';

import * as ent from '../../entities/index'
import * as filters from '../../filters/index'
import * as serv from '../../services/index'

//constants
import { Constants } from '../../constants/Constants';

//base
import { BaseDropdownComponent } from '../../baseclasses/BaseDropdown.component';

@Component({
    selector: 'my-contact-function-dropdown',
    templateUrl: './ContactFunctionDropdown.component.html',
    providers: [{ provide: BaseDropdownComponent, useExisting: forwardRef(() => ContactFunctionDropdownComponent) }]
})
export class ContactFunctionDropdownComponent extends BaseDropdownComponent {

    records: ent.ContactFunction[] = [];
    constructor(private domainDataService: serv.DomainDataService) {
        super();
    }

    @Input() setValueToDefault: boolean;


    ngOnInit(): void {
    }

    public load() {

        this.domainDataService.getContactFunctions({ IncludeInactive: false }).subscribe(x => this.onGetRecordsDone(x));
    }

    onGetRecordsDone(items: ent.ContactFunction[]) {
        this.records = items;
        this.selectItems.push({ label: "", value: Constants._NONE });
        items.forEach(y => this.selectItems.push({ label: y.FullName, value: y.ID }));
        if (this.selectedID) {
            this.value = this.selectedID;
        } 
        else{
            if (this.setValueToDefault){
                var defaultItems = items.filter(x=>x.ID == Constants._DEFAULT_CONTACT_FUNCTION_ID);
                if (defaultItems.length > 0){
                    this.value = defaultItems[0].ID;
                }
            }
            
        }

    }

}